module.exports = __webpack_public_path__ + "static/media/ux-score-full.6f63b842.png";